import Delayed from '@core/Delayed';
import type { TableEmptyViewProps } from '@core/table/types';
import Typography from '@core/Typography';

import getEmptyViewCss, { classes } from './styles/getEmptyViewCss';

const EmptyView = (props: TableEmptyViewProps) => {
  const { label, supportText, description, actions, ...rest } = props;
  return (
    <div aria-live="polite" css={getEmptyViewCss} role="region" {...rest}>
      <Delayed>
        <div>
          <Typography color="supportText" variant="h2semibold">
            {label}
          </Typography>
          {supportText && (
            <Typography
              className={classes.supportText}
              color="supportText"
              variant="h3semibold"
            >
              {supportText}
            </Typography>
          )}
          {description && (
            <Typography className={classes.description}>
              {description}
            </Typography>
          )}
          {actions && <div className={classes.actions}>{actions}</div>}
        </div>
      </Delayed>
    </div>
  );
};

export default EmptyView;
